import React from 'react';
import bemify from 'bemify-js';

import BashCodeBlock from '../components/BashCodeBlock';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('install-cli');

const InstallCLI = () => (
  <div className={bem()}>
    <StepTitle>Install the Zapier CLI</StepTitle>
    <Paragraph>
      Next let's install the Zapier CLI tools. The CLI will allow you to build
      your app, deploy it to the Zapier platform, do local testing, manage users
      and testers, view remote logs, collaborate with your team, and more:
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: '# install the CLI globally',
          isComment: true,
        },
        {
          content: 'npm install -g zapier-platform-cli',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>To test that everything worked:</Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: 'zapier --version',
          isCommand: true,
        },
        {
          content: `zapier-platform-cli/X.Y.Z`,
          isComment: true,
        },
        {
          content: 'node/vX.Y.Z',
          isComment: true,
        },
      ]}
    />
  </div>
);

export default InstallCLI;
